import { Popover } from '@mui/material';
import { useState } from 'react';

import PhoneIcon from '../../../assets/svg/PhoneIcon';
import PlusIcon from '../../../assets/svg/PlusIcon';
import { WidgetCard } from '../WidgetCard';

const getData = ({ totals, notInterestedBreakdown, doNotCallBreakdown }) => [
  { label: 'Callback', value: totals.callback },
  { label: 'Email sent', value: totals.email },
  {
    label: 'Not Interested',
    value: totals.notInterested,
    options: [
      { label: 'No budget', value: notInterestedBreakdown.noBudget },
      {
        label: 'Uses competitor',
        value: notInterestedBreakdown.usesCompetitor,
      },
      { label: 'Not a good time', value: notInterestedBreakdown.notAGoodTime },
      {
        label: 'No need for our service',
        value: notInterestedBreakdown.noNeedForOurService,
      },
    ],
  },
  { label: 'No Answer', value: totals.noAnswer },
  { label: 'Hung Up', value: totals.hangUp },
  {
    label: 'Do Not Call',
    value: totals.doNotCall,
    options: [
      { label: 'Wrong Contact', value: doNotCallBreakdown.wrongContact },
      { label: 'Wrong Number', value: doNotCallBreakdown.wrongNumber },
      { label: 'Bad Number', value: doNotCallBreakdown.badNumber },
      {
        label: 'Company not in business',
        value: doNotCallBreakdown.companyNotInBusiness,
      },
      {
        label: 'No Longer with Company',
        value: doNotCallBreakdown.noLongerWithCompany,
      },
      { label: 'Retired', value: doNotCallBreakdown.retired },
      { label: 'Remove from List', value: doNotCallBreakdown.removeFromList },
      {
        label: 'Unsuitable company',
        value: doNotCallBreakdown.unsuitableCompany,
      },
      { label: 'Current customer', value: doNotCallBreakdown.currentCustomer },
    ],
  },
];

export const ChartDialOutcomes = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const onOpenPopover = e => {
    setAnchorEl(e.currentTarget);
  };

  const onClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <WidgetCard title="Dial Outcomes" Icon={PhoneIcon}>
      <div className="grid grid-rows-2 grid-cols-3 gap-5 pt-5 pb-2">
        {getData(data).map((v, idx) => (
          <div key={idx} className="flex flex-col gap-1">
            <span className="text-[14px]/[20px] font-medium text-base-800">
              {v.label}
            </span>
            <div className="flex items-center gap-1.5">
              <span className="text-[22px]/[28px] font-semibold text-base-1000 truncate">
                {v.value}
              </span>
              {!!v.options && (
                <>
                  <button
                    onClick={e => {
                      setSelectedItem(v);
                      onOpenPopover(e);
                    }}
                    className="w-[18px] h-[18px] rounded-full border border-brand-300/30 outline-none flex justify-center items-center"
                  >
                    <PlusIcon className="w-3 h-3 text-brand-500" />
                  </button>
                  <Popover
                    open={open}
                    slotProps={{
                      paper: {
                        className:
                          '!rounded-lg -mt-3 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-[220px]',
                      },
                    }}
                    anchorEl={anchorEl}
                    onClose={onClosePopover}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                  >
                    {!!selectedItem && (
                      <div className="flex flex-col gap-2.5 px-3 py-2.5">
                        <span className="text-[14px]/[150%] font-semibold text-base-1000">
                          {selectedItem.label}
                        </span>
                        <div className="flex flex-col gap-2">
                          {selectedItem.options.map(({ value, label }, idx) => (
                            <div
                              key={idx}
                              className="flex items-center justify-between gap-2"
                            >
                              <span className="text-[12px]/[16px] text-base-800 text-nowrap">
                                {label}
                              </span>
                              <span className="text-[14px]/[16px] font-medium text-base-1000 truncate">
                                {value}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </Popover>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </WidgetCard>
  );
};
